import { render, staticRenderFns } from "./correctArticles.vue?vue&type=template&id=366afef2&scoped=true"
import script from "./correctArticles.vue?vue&type=script&lang=js"
export * from "./correctArticles.vue?vue&type=script&lang=js"
import style0 from "./correctArticles.vue?vue&type=style&index=0&id=366afef2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366afef2",
  null
  
)

export default component.exports